import pendingReasonsService from "../../../services/pending-reasons/PendingReasonsService";
import PendingService from "../../../services/PendingService";

export default {
  data() {
    return {
      dialog: false,
      pendingReasonItems: [],
      disablePendingReason: false,
      search: "",
      headers: [
        {
          text: "#Orden",
          sortable: false,
          value: "numOrder"
        },
        {
          text: "PLU",
          sortable: false,
          value: "plu"
        },
        {
          text: "Descripción",
          value: "description",
          sortable: false
        },
        {
          text: "Cantidad",
          value: "count",
          sortable: false
        },
        {
          text: "Cantidad de entregados",
          value: "numberDelivered",
          sortable: false
        },
        {
          text: "Cantidad de pendientes",
          value: "amountEarrings",
          sortable: false
        },
        { text: "Motivo", value: "reason", sortable: false }
      ],
      itemsData: [],
      rowsPerPageItems: [5, 10, 15, 20]
    };
  },
  props: ["medicineList", "orderId"],
  watch: {
    medicineList() {
      this.itemsData = this.medicineList;
    }
  },
  created() {
    this.getPendingReason();
  },
  methods: {
    onRowClick(item) {
      this.$emit("row-click", item);
    },
    getValidDeliveredCount(a, b) {
      return a <= b ? a : b;
    },
    getPendingReason() {
      pendingReasonsService.getPendings().then(response => {
        this.pendingReasonItems = response.data;
      });
    },
    getPendingReasonName(id) {
      let pendingReasonItem = this.pendingReasonItems.find(
        item => item.id === id
      );
      return pendingReasonItem ? pendingReasonItem.name : "";
    },
    updatePendingReason(item) {
      item.deliveredQuantity = item.deliveredQuantity > -1 ? item.deliveredQuantity : 0;

      item.disablePendingReason = +item.quantity - +item.deliveredQuantity === 0;

      item.deliveredQuantity = item.deliveredQuantity > item.quantity
        ? item.quantity
        : item.deliveredQuantity

      item.pendingReason = (item.quantity - item.deliveredQuantity) <= 0 ? null : item.pendingReason;
    },
    updatePending() {
      try {
        let data = {
          orderId: this.orderId,
          medicines: this.itemsData.map(item => {
            if (!+item.quantity - +item.deliveredQuantity === 0) {
              if (!item.pendingReason)
                throw `Debe seleccionar un motivo para la medicina con PLU ${
                item.pluCode
                }!`;
            }

            let medicine = {
              id: item.id,
              pendingReasonId: item.idPendingReason.id,
              deliveredCount: item.deliveredQuantity
                ? parseInt(item.deliveredQuantity)
                : 0
            };
            return medicine;
          })
        };

        PendingService.updatePending(data).then(result => {
          if (result) {
            this.$notify({
              group: "app",
              type: "success",
              text: "Pendiente actualizado correctamente!"
            });
            this.closePending();
          } else {
            this.$notify({
              group: "app",
              type: "error",
              text: "Ha ocurrido un error al actualizar el pendiente!"
            });
          }
        });
      } catch (error) {
        this.$notify({
          group: "app",
          type: "error",
          text: error
        });
      }
    },
    closePending() {
      this.dialog = false;
      this.itemsData = [];
      this.$emit("close-pending", false);
    },
    save(pendingReason) {

    }
  }
};
